<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    content-class="user-profile-menu-content"
    max-width="500px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on">
        {{ icons.mdiRocketLaunchOutline }}
      </v-icon>
    </template>

    <v-card class="app-bar-notification-content-container">
      <perfect-scrollbar
        class="ps-user-notifications"
        :options="perfectScrollbarOptions"
      >
        <v-card-text class="pt-4">
          <v-row class="ma-0 mt-n1">
            <template v-for="(shortcut, index) in shortcuts">
              
              <!-- DIVIDER SECTION -->
              <v-col
                v-if="shortcut.divider"
                :key="'divider-' + index"
                cols="12"
                class="d-flex align-center my-3 pa-0"
              >
                <v-divider></v-divider>
                <span class="mx-3 text-overline grey--text text--darken-1 text-no-wrap">
                  {{ shortcut.title }}
                </span>
                <v-divider></v-divider>
              </v-col>

              <!-- SQUARE ICON SECTION -->
              <v-col
                v-else
                :key="shortcut.title"
                cols="3"
                class="pa-1" 
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- The Card is the Square -->
                    <v-card
                      :href="shortcut.to"
                      target="_blank"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      hover
                      class="shortcut-card d-flex align-center justify-center"
                    >
                      <!-- v-responsive forces the 1:1 Aspect Ratio -->
                      <v-responsive :aspect-ratio="1" class="d-flex align-center justify-center w-full">
                        <div class="d-flex align-center justify-center fill-height pa-3">
                            <v-img
                                :src="require(`@/assets/images/launchpad/${shortcut.img}`)"
                                contain
                                max-height="100%"
                                max-width="100%"
                            ></v-img>
                        </div>
                      </v-responsive>
                    </v-card>
                  </template>
                  <span>{{ shortcut.title }}</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </perfect-scrollbar>
    </v-card>
  </v-menu>
</template>

<script>
import {mdiRocketLaunchOutline} from '@mdi/js'


import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
export default {
    components: {
        PerfectScrollbar,
    },
    setup(props) {
        
        const perfectScrollbarOptions = {
        maxScrollbarLength: 60,
        wheelPropagation: false,
        }

        
        const shortcuts = [
            {
                title:"BVA Credentials needed",
                divider:true
            },
            {
                title: "Decipher",
                img: "forsta.png",
                to: "https://emea.focusvision.com/login"
            },
            {
                title: "E-Tabs",
                img: "etabs.png",
                to: "https://ecloud.e-tabs.com/"
            },
            {
                title: "Caplena",
                img: "caplena.png",
                to: "https://caplena.com/app/"
            },
            {
                title: "Expert System",
                img: "expertsystem.png",
                to: "https://client.prsiv.polynom.io/routes/studies"
            },
            {
                title: "VizAI",
                img: "dragonflyai.png",
                to: "https://app.dragonflyai.co/"
            },
            {
                title: "ET System",
                img: "et.png",
                to: "https://kawaprs-bvagroup.msappproxy.net/"
            },
            {
                title: "Shelfgram",
                img: "shelfgram.png",
                to: "https://shelfgram.com/"
            },
            {
                title: "CMAP",
                img: "cmap.png",
                to: "https://bva-group.cmaphq.com/"
            },
            {
                title: "Timesheet Portal",
                img: "timesheet.png",
                to: "https://bvagroup.timesheetportal.com/"
            },
            {
                title:"IPSOS Credentials needed",
                divider:true
            },
            {
                title: "Quant Pricing",
                img: "quant_pt.png",
                to: "https://ipsosgroup.sharepoint.com/teams/ExtSP-BVA-PRSIV-GrandCentral/Shared%20Documents/3.%20PILLARS%20&%20SERVICES/00.%20CALCULATORS,%20PRICE%20CARDS%20&%20TERMS/PRSIV%20PRICER%20QUANT.xlsm"
            },
            {
                title: "Qual Pricing",
                img: "qual_pt.png",
                to: "https://ipsosgroup.sharepoint.com/teams/ExtSP-BVA-PRSIV-GrandCentral/Shared%20Documents/3.%20PILLARS%20&%20SERVICES/00.%20CALCULATORS,%20PRICE%20CARDS%20&%20TERMS/PRSIV%20PRICER%20QUAL.xlsm"
            },
            {
                title: "RFFQ",
                img: "rffq.png",
                to: "https://ipsosgroup.sharepoint.com/:x:/r/teams/ExtSP-BVA-PRSIV-GrandCentral/Shared%20Documents/1.%20ORIENTATION%20%26%20OPERATIONS/2.%20PROCESSES/Templates/RFFQ.xlsx?d=w8bf41c91e3ab426db2be552a59949351&csf=1&web=1&e=TLSmE9"
            },
            {
                title: "Grand Central",
                img: "gc.png",
                to: "https://ipsosgroup.sharepoint.com/teams/ExtSP-BVA-PRSIV-GrandCentral"
            },
            {
                title: "SharePoint",
                img: "sharepoint.png",
                to: "https://ipsosgroup.sharepoint.com/_layouts/15/sharepoint.aspx"
            },
            {
                title: "PPTX Template",
                img: "pptx_template.png",
                to: "https://ipsosgroup.sharepoint.com/:f:/r/teams/ExtSP-BVA-PRSIV-GrandCentral/Shared%20Documents/2.%20MARKETING/1.%20BRAND%20EQUITY%20-%20PRS%20IN%20VIVO/Assets%20for%20IPSOS%20Branding/All%20PPT%20themes%20and%20templates?csf=1&web=1&e=H4lxgg"
            },
        ]

        
        return {
            shortcuts,
            perfectScrollbarOptions,
            icons: {
                mdiRocketLaunchOutline
            }
        }

    }
}

</script>


<style scoped>
.shortcut-card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border-radius: 8px; /* Optional: rounded corners for the square */
}

.shortcut-card:hover {
  transform: translateY(-2px);
  background-color: rgba(0, 0, 0, 0.02); /* Light highlight on hover */
}

/* Ensure the image container takes full height/width of the square */
.w-full {
    width: 100%;
}
</style>
